import request from '@/utils/request'
//get
export function getMaterialByParam(param) {
  return request({
    url: `/adtemplate/${param}`,
    method: 'GET'
  })
}
export function createMaterial(data) {
  return request({
    url: `/adtemplate/`,
    method: 'POST',
    data
  })
}

export function readMaterial(id) {
  return request({
    url: `/adtemplate/${id}/`,
    method: 'GET'
  })
}


export function updateMaterial(data,id){
  return request({
    url: `/adtemplate/${id}/`,
    method: 'PATCH',
    data
  })
}

export function deleteMaterial(id) {
  return request({
    url: `/adtemplate/${id}/`,
    method: 'DELETE'
  })
}


// WEBPACK FOOTER //
// ./src/api/material.js